import { cn } from '../cn';

import type { ButtonHTMLAttributes } from 'react';

export interface SwitchProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'onChange' | 'type'> {
  checked?: boolean | undefined;
  onChange?: ((checked: boolean) => void) | undefined;
}

/** On/off control. Label it with `aria-label` or `aria-labelledby`. */
export function Switch({ checked = false, onChange, disabled = false, className, ...rest }: SwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => onChange?.(!checked)}
      className={cn(
        'box-border inline-flex h-6 w-10 shrink-0 items-center rounded-full p-[3px] transition-colors duration-150',
        checked ? 'bg-surface-action-primary-default' : 'bg-surface-static-neutral-active',
        disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
        className,
      )}
      {...rest}
    >
      <span
        aria-hidden="true"
        className={cn(
          'block size-[18px] rounded-full bg-surface-static-default shadow-1 transition-transform duration-150',
          checked ? 'translate-x-4' : 'translate-x-0',
        )}
      />
    </button>
  );
}
